<template>
  <div>
    <div class="card  border-0 mb-3">
      <div class="card-body">
        <h3>Поднять задание</h3>
        <div class="alert alert-info">
          Если вы заметили, что ваше задание выполняется медленно, вы
          можете поднять его в списке на первое место. Постепенно оно будет снижаться в списке по мере добавления
          новых заданий или поднятия других заданий. Стоимость поднятия в общем списке заданий 1 руб.
        </div>
        <table class="table-responsiver">
          <p> </p>
          <tr>
            <td>Задание:</td>
            <td>{{ task.title }}</td>
          </tr>
          <tr>
            <td>Ваше задание на:</td>
            <td>{{ position }} месте</td>
          </tr>
          <tr>
            <td>Задание поднималось:&nbsp;</td>
            <td>{{ task.promoted_at }}</td>
          </tr>
        </table>
        <br>
        <div class="d-flex justify-content-center mt-1">
          <button class="btn btn-primary me-2" @click="promoteTask">
            <span v-show="!loading"><i class="fas  fa-circle-chevron-up me-1"></i> Поднять сейчас за 1 рубль</span>
          </button>
          <button @click="$router.push(`/task/${id}/show`).catch(() => { });"
            class="btn btn-default w-100px ">Отмена</button>
        </div>
      </div>
    </div>

    <div class="card  border-0 mb-3">
      <div class="card-body">

        <div action="/" method="POST">
          <fieldset>
            <legend class="mb-3">Автоматическое поднятие задания</legend>
            <div class="row mb-3">
              <label class="form-label col-form-label col-md-3">Интервал:</label>
              <div class="col-md-9">

                <select v-model="task.promote_every" class="form-control" id="floatingInput">
                  <option value="0">Выключено</option>
                  <option value="1">1 мин</option>
                  <option value="3">3 мин</option>
                  <option value="5">5 мин</option>
                  <option value="10">10 мин</option>
                  <option value="15">15 мин</option>
                  <option value="30">30 мин</option>
                  <option value="60">1 час</option>
                  <option value="180">3 часа</option>
                  <option value="360">6 часов</option>
                  <option value="720">12 часов</option>
                  <option value="1440">1 сутки</option>
                  <option value="2880">2 суток</option>
                  <option value="4320">3 суток</option>
                </select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="form-label col-form-label col-md-3">Количество поднятий:</label>
              <div class="col-md-9">
                <input v-model="task.promote_count" type="number" class="form-control" placeholder="1000">
                <!--<small>Максимальные расходы: ~1000 руб. за 7 дн.</small> -->
                <small>Допустимые значения: от 0 до 1000</small>
              </div>
            </div>
            <div class="row">
              <div class="col-md-7 offset-md-3">
                <button @click="autoPromoteTask" class="btn btn-primary w-100px me-5px">Сохранить</button>
                <button @click="$router.push(`/task/${id}/show`).catch(() => { });"
                  class="btn btn-default w-100px ">Отмена</button>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import HTTP from "../http";
import {show_error, show_message} from "../message";

export default {
  components: {
  },
  data() {
    return {
      id: 0,
      mes: "",
      task: {link: 'link'},
      status: "ACCEPTED",
      up_time: 15,
      loading: false,
      user: {},
      position: 0
    };
  },

  created() {
    this.id = this.$route.params.id
    this.fetchData();
  },


  methods: {
    autoPromoteTask() {
      this.$insProgress.start();
      HTTP()
        .put(`/auto_promote/${this.id}`, {promote_count: this.task.promote_count, promote_every: this.task.promote_every})
        .then((resp) => {
          this.task = resp.data.task
          this.user = resp.data.user
          this.position = resp.data.position
          localStorage.setItem('user', JSON.stringify(resp.data.user))
          window.eventBus.$emit('user.update', resp.data.user)
          show_message(this.$notify, 'Сохранено')
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
    promoteTask() {
      this.$insProgress.start();
      HTTP()
        .put(`/promote/${this.id}`)
        .then((resp) => {
          this.task = resp.data.task
          this.user = resp.data.user
          this.position = resp.data.position
          localStorage.setItem('user', JSON.stringify(resp.data.user))
          window.eventBus.$emit('user.update', resp.data.user)
          show_message(this.$notify, 'Вы успешно подняли задание')
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
    fetchData() {
      this.$insProgress.start();
      HTTP()
        .get(`/promote/${this.id}`)
        .then((resp) => {
          this.task = resp.data.task
          this.user = resp.data.user
          this.position = resp.data.position
          localStorage.setItem('user', JSON.stringify(resp.data.user))
          window.eventBus.$emit('user.update', resp.data.user)
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    }
  }
}
</script>


<style>
.task-href {
  cursor: pointer;
  text-decoration: none;
  color: var(--bs-body-color);
}

.task-href:visited {
  color: var(--bs-body-color);
}

.task-href:hover {
  color: var(--bs-body-color);
}
</style>